import React from 'react';
import { styled } from '@compiled/react';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';
import type { CascadingSelectOption } from '../../common/types.tsx';

export const formatOptionLabel = ({ label, isInvalid, invalidMessage }: CascadingSelectOption) => {
	if (isInvalid) {
		return (
			<InvalidOption>
				<InvalidOptionText>{label}</InvalidOptionText>
				<InvalidOptionIconWrapper>
					<StatusErrorIcon color={token('color.icon.danger')} label={invalidMessage ?? ''} />
				</InvalidOptionIconWrapper>
			</InvalidOption>
		);
	}

	return label;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InvalidOption = styled.div({
	color: token('color.text.danger'),
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InvalidOptionText = styled.span({
	flexShrink: 1,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InvalidOptionIconWrapper = styled.span({
	flexShrink: 0,
});
